<template>
  <div>
    <div class="flex" style="display:flex; justify-content: space-between;">
      <el-button size="small" @click="downloadReport('EXCEL')" class="mr-10">
        <i class="mdi mdi-download"></i>
      </el-button>
      <div style="display: flex; ">
        <el-select v-model="filters" multiple size="small" collapse-tags style="width:300px;height:auto" @change="handleStatutChanged">
          <el-option
            v-for="item in salesOrderStatuses"
            :key="item.id"
            :label="$t('sales_orders.statuses.'+item.code)"
            :value="item.id">
          </el-option>
        </el-select>
        <el-link type="info" @click="resetFilters" class="ml-5">
          <i class="mdi mdi-filter-remove"/>
        </el-link>
      </div>
      <div class="flex justify-space-between">
        <Pagination
          class="mt-5 mb-0 fs-14 secondary-text"
          :current-page="page"
          :total-number-of-page="totalPages"
          @click-previous="clickPrevious"
          @click-next="clickNext" />
      </div>
    </div>

    <el-skeleton :count="1" animated :loading="loading">
      <template slot="template">
        <tableSkeleton :rows="40" :columnLabel="[{ label: 'Date', width:100, sortable:false}, { label: 'No. commande', width:160, sortable:false},{ label: 'Client', sortable:false}, {label: 'Qte', width:60, sortable:false}, {label: 'Statut', width:160, sortable:false}]"></tableSkeleton>
      </template>
      <template>
        <el-table
          :data="sales"
          stripe
          :empty-text="$t('sales_orders.no_sales_orders')"
          :cell-style="{padding:'2px'}"
          style="width: 100%">
          <el-table-column
            prop="date"
            width="100"
            :label="$t('common.date')">
            <template slot-scope="scope">
              {{moment(scope.row.date, 'l')}}
            </template>
          </el-table-column>
          <el-table-column
            prop="so_number"
            width="160"
            :label="$t('sales_orders.soNumber')">
            <template slot-scope="scope">
              <PortausLink path="/sales-orders/" :id="scope.row.id" :label="scope.row.soNumber"></PortausLink>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('sales_orders.customer')">
            <template slot-scope="scope">
              <PortausLink path="/customers/" :id="scope.row.customer.id" :label="getCustomerName(scope.row.customer)"></PortausLink>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            :label="$t('common.qty')">
            <template slot-scope="scope">
              {{getSalesProductQuantity(scope.row.lines, puid)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="status.code"
            align="center"
            width="160"
            :label="$t('common.status')">
            <template slot-scope="scope">
              <SalesOrderStatusTag :status="scope.row.status" size="small"/>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-skeleton>
  </div>
</template>
<script>
import moment from 'moment'
import PortausLink from '@/components/portaus-link'
import salesOrderAPI from '@/services/API/sales-order'
import CustomerUtil from '@/utils/customer-util'
import tableSkeleton from '@/components/skeleton/table-skeleton'
import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'
import Pagination from '@/components/pagination.vue';
import salesAPI from '@/services/API/sales.js'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  name: 'sales-item-table',
	props: {
    puid : {
      type: String
    },
    pageLimit : {
      type: Number,
      default : 10,
    },
    productName : {
      type: String,
      requried : true
    }
	},
  data() {
    return {
      filters: [],
      sales : [],
      loading : true,
      page: 1,
      totalPages: 0,
    };
  },components: {
    PortausLink,
    SalesOrderStatusTag,
    tableSkeleton,
    Pagination
  },
  watch : {
    puid : function(val){
      this.fetchSales();
    },
  },
	methods: {
    handleStatutChanged(){
      this.fetchSales();
    },
    resetFilters(){
      this.filters = [];
      this.fetchSales();
    },
    downloadReport(format){
      this.downloading=true;

      return salesAPI.downloadTransactionSalesReport({puid:this.puid,format}, this.productName+'-commandes.xlsx')
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          console.log(err);
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
    },
    clickPrevious () {
      if (this.page > 1) {
          this.page -= 1;
      }
      this.fetchSales();
    },
    clickNext () {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.fetchSales();
      }
    },
    getSalesProductQuantity(lines, puid){
      let qty = 0;
      _.forEach(lines, (l) => {
        if (l.puid === puid) {
          qty += l.qty;
        }
      })
      return qty;
    },
    getCustomerName(customer){
      return CustomerUtil.customerName(customer.name, customer.usualName);
    },
    moment(datetime, format='DD/MM/YYYY'){
      return moment(datetime).format(format);

    },
    openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
      this.$router.push(index);
    },
    fetchSales(){
      this.loading = true;
      if(this.puid!=null){
        const statusId = _.map(this.filters, f => (f));
        return salesOrderAPI.fetchSalesOrders({ statusId, puid: this.puid, paging: true, page: this.page, limit: this.pageLimit}, ['customer'])
          .then(response => {
            this.sales = response.list;
            this.totalPages = response.pages;
            this.loading = false;
          }).catch(err=> {
            this.loading = false;
          })
      }
    },
    ...mapActions('statuses', ['fetchSalesOrderStatuses']),
	},
	computed: {
    ...mapState('statuses', ['salesOrderStatuses'])

	},
  mounted(){
    this.fetchSalesOrderStatuses()
      .then(() => {
        this.filters = _.map(this.salesOrderStatuses, s => (s.id));
      })
      this.fetchSales();
  }
}
</script>
<style lang="scss" scoped>




</style>
